<script>
    import {_} from "svelte-i18n";
    import PackListing from "../PackListing.svelte";
    import Modal from '../Modal.svelte';
    import LuckyDrawModal from "../modals/LuckyDrawModal.svelte";
    import {logMetric} from "../../metrics.js";
    import {luckyDrawEvent, navigateToSection} from "../../stores.js";
    import {goTo} from "../../utils.js";
    import {onMount} from "svelte";

    function redirectToDailyDeals() {
        navigateToSection('dailyDeals');
    }

    let { lucky_draw_modal_hide = (x, dont_redirect) => {
        if (typeof dont_redirect === 'undefined') {
            redirectToDailyDeals();
        }
        lucky_draw_modal_open = false;
        logMetric({button: 'lucky-draw-close-modal'});
    } } = $props();

    let show_lucky_draw_packs = $state(false);
    const lucky_draw_packs_show = () => show_lucky_draw_packs = true;

    let lucky_draw_modal_open = $state(false);
    const lucky_draw_modal_show = () => lucky_draw_modal_open = true;

    if (localStorage.getItem("luckyDrawSeen") === null) {
        localStorage.setItem("luckyDrawSeen", "true");
    }

    if (!$luckyDrawEvent.availableDiscount) {
        lucky_draw_modal_show();
    } else {
        lucky_draw_packs_show();
    }

    onMount(() => {
        goTo('/supplies/luckyDraw', true);
    });
</script>

<div class="luckyDraw">
    {#if show_lucky_draw_packs}
        <section class="pack-listing">
            <PackListing
                    storeSection="luckyDraw"
                    title={$_('LuckyDraw')}
            />
        </section>
    {/if}
</div>

<Modal class="lucky-draw-modal-wrapper" bind:open={lucky_draw_modal_open}>
    <LuckyDrawModal {lucky_draw_modal_hide} {lucky_draw_packs_show}/>
</Modal>

<style lang="scss">
  @use '../../styles/vars.scss' as *;

  :global {
  }
</style>
